import React from 'react';
import ColorWrapper from '@styles/colors';
import BaseFrame from '@components/settings/components/modules/baseFrame';
import { isPhone } from '@helpers';
import { OperationSearchItem } from '@interfaces/search';
import { WithColor } from '@styles/colors';
import { useManageJobMachinesModal } from '@v2/pages/machines/modules/now/components/Job/hooks/useManageJobMachinesModal';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

export interface JobMachinesModalProps extends WithColor {
  jobIds: number[];
  job: OperationSearchItem;
  customOnSelect?: (machineNameId: { id: number | null; name: string }) => void;
  selectedMachineId?: number | null;
  hide?: () => void;
}

const MODAL_HEIGHT = 250;

const JobMachinesModal = (props: JobMachinesModalProps) => {
  const { job, jobIds, customOnSelect, selectedMachineId } = props;

  const {
    submitLoading,
    data,
    onCancel,
    onSelect,
    onSubmit,
    selected,
  } = useManageJobMachinesModal({ job, jobIds, customOnSelect, selectedMachineId });

  return (
    <BaseFrame
      {...{
        testID: TEST_IDS.jobContent.machinesModal,
        submitLoading,
        data: data,
        onCancel,
        onSelect,
        onSubmit,
        header: 'Select Machine',
        selected,
        ...(!isPhone && { maxHeight: MODAL_HEIGHT }),
        itemOffset: 42,
        checkTopK: 0.34,
        ...props,
      }}
    />
  );
};

export default ColorWrapper(JobMachinesModal);
